<template>
    <div style="display:inline-block">
        <div v-if="entry.Reversed" class="status reversed">
            REVERSED
        </div>
        <div v-else-if="entry.BillingWorksheetId === null" class="status not-invoiced">
            NOT INVOICED
            <span v-if="nonBillable"><br />NOT BILLABLE</span>
        </div>
        <div v-else-if="entry.BilledDate === null && entry.ParentWorksheetId === null" class="status bw-active">
            WORKSHEET CREATED
            <span v-if="nonBillable"><br />NOT BILLABLE</span>
        </div>
        <div v-else class="status invoiced">
            INVOICED
            <span v-if="nonBillable"><br />NOT BILLABLE</span>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        props: {
            entry: Object
        },
        computed: {
            nonBillable() {
                return this.entry.NonBillable || this.entry.ActivityCode === 'CLS' || this.entry.ActivityCode === 'AR';
            }
        }
    };
</script>